import { S3_BUCKET_DRIFT_PUBLIC_MAINNET } from 'src/constants/constants';

/**
 * How to compress videos for the announcements, and convert from mp4 to webm:
 * - ensure you have ffmpeg installed
 * - run the command: ffmpeg -i input.mp4 -c:v libvpx-vp9 -b:v 0 -crf 32 -c:a libopus output.webm
 */
export const FEATURE_ANNOUNCEMENT_S3_BUCKET_PATH = `${S3_BUCKET_DRIFT_PUBLIC_MAINNET}/announcements`;

/**
 * Use an online image converter, to convert from png to webp.
 */
export const FEATURE_ANNOUNCEMENT_PREVIEW_IMAGES_PATH =
	'/assets/images/announcements/previews';
